import React, { useState, useEffect } from "react";
import { Space, Col, Row } from "antd";
import BusinessModal from "../business_pages/components/BusinessForm";
import SuccessModal from "../business_pages/components/SuccessModal";
import envelope from "./images/envelope.svg";
import { useMediaQuery } from "react-responsive";

const ContactSection = () => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  return (
    <>
      <div style={{ marginBottom: -100 }}>
        <Row align="middle">
          <Col span={24} md={{ span: 12 }} xl={{ span: 8, offset: 4 }} order={2} lg={{ order: 1 }} style={{
            padding: isMobileScreen ? 20 : 16
          }}>
            <img
              style={{ width: isMobileScreen ? "100%" : "90%" }}
              src={envelope}
            />
          </Col>
          <Col span={24} md={{ span: 12 }} xl={{ span: 9 }} order={1} lg={{ order: 2 }}>
            <div style={{ padding: 20 }}>
              <div className="header-title-3" style={{ marginBottom: 20 }}>
                {"Susisiek su mumis tau patogiu būdu"}
              </div>

              <Row gutter={[32, 32]} style={{ marginTop: '25px' }}>
                <Col span={24} lg={{ span: 12 }}>
                  <Space>
                    <img src="/imgs/business-page/envelope.svg" />
                    <div className="info-font nice-select">
                      <a href="mailto: pardavimai@alsendo.lt">
                        {"pardavimai@alsendo.lt"}
                      </a>
                    </div>
                  </Space>
                </Col>
                <Col span={24} lg={{ span: 12 }}>
                  <Space>
                    <img src="/imgs/business-page/phone.svg" />
                    <div className="info-font nice-select">
                      <a href="tel: +37065828980">{"+370 658 28980"}</a>
                    </div>
                  </Space>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {isFormModalVisible && (
          <BusinessModal
            setIsFormModalVisible={setIsFormModalVisible}
            setIsSuccessModalVisible={setIsSuccessModalVisible}
          />
        )}
        {isSuccessModalVisible && (
          <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
        )}
      </div>
    </>
  );
};

export default ContactSection;
